import React, { useState } from 'react'
import cn from 'classnames'
import { observer, useStore } from '@/hooks/storeHooks'
import st from './index.scss'
import { makeAutoObservable } from 'mobx'

class ImgProviewStore {
    constructor() {
        makeAutoObservable(this)
    }
}

export default observer(function ImgProview({ url, width, height, cancelPop }) {
    const [store] = useState(() => new ImgProviewStore())

    if (!width && !height) {
        width = '200px'
        height = '200px'
    }

    return (
        <>
            <div>
                <img
                    className={st['proviewImg']}
                    src={url}
                    style={{ width: width + 'px', height: height + 'px' }}
                    alt=""
                    onClick={() => {
                        cancelPop && cancelPop()
                    }}
                />
            </div>
        </>
    )
})
